import { IWPImage } from "@/src/types";
import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import S from "./NewsBlock.styled";
import { MainInner } from "@/styles/global";
import { AnimationOnScroll } from "react-animation-on-scroll";

export interface Props {
  animation: string;
  title: string;
  news: {
    featuredImage: {
      node: IWPImage;
    };
    title: string;
    uri: string;
  }[];
}

const NewsBlock: React.FC<Props> = ({ animation, title, news }) => {
  const [limitedNews, setLimitedNews] = React.useState(news.slice(0, 6));

  // add 6 more news items to the list at a time
  const handleLoadMore = () => {
    setLimitedNews((prev) => [
      ...prev,
      ...news.slice(prev.length, prev.length + 6),
    ]);
  };

  const renderNews = limitedNews.map((newsItem, i) => {
    const { featuredImage, title, uri } = newsItem;
    const newsImageData = featuredImage?.node?.localFile?.childImageSharp
      ?.gatsbyImageData
      ? getImage(featuredImage.node.localFile.childImageSharp.gatsbyImageData)
      : null;

    // split title into two at the first .
    const splitTitle = title.split(".");
    const firstTitle = splitTitle[0];
    const secondTitle = splitTitle.slice(1).join(".");

    return (
      <S.CardLink to={uri} key={i}>
        {newsImageData && (
          <AnimationOnScroll
            animateIn={`animate__${animation}`}
            animateOnce={true}
            initiallyVisible={animation == "none" ? true : false}
            duration={animation === "none" ? 0 : 1}
            delay={animation === "none" ? 0 : 100}
          >
            <S.ImageWrapper>
              <S.CardImage image={newsImageData} alt="" />
            </S.ImageWrapper>
          </AnimationOnScroll>
        )}
        <S.TitlesWrapper>
          {firstTitle && (
            <S.FirstTitle>
              {firstTitle}
              {". "}
            </S.FirstTitle>
          )}
          {secondTitle && <S.SecondTitle>{secondTitle}</S.SecondTitle>}
        </S.TitlesWrapper>
      </S.CardLink>
    );
  });

  return (
    <MainInner>
      <S.Container>
        {title && <S.Title>{title}</S.Title>}
        <S.Grid>{renderNews}</S.Grid>
        {news.length > limitedNews.length && (
          <S.LoadMoreButton onClick={handleLoadMore}>More +</S.LoadMoreButton>
        )}
      </S.Container>
    </MainInner>
  );
};

export default NewsBlock;
